import React, { useEffect, useRef, useState } from 'react';
import { useLocation } from "react-router-dom";
import { Drawer } from 'antd';
import { createBreakpoint } from "react-use";

const useBreakpoint = createBreakpoint({ tablet: 768, mobile: 0 });

const SidebarComponent = ({ defaultClosed, canClose, ...props }) => {
    const breakpoint = useBreakpoint();
    const location = useLocation();
    const refContainer = useRef(null);
    const [isSidebarVisible, setIsSidebarVisible] = useState(!defaultClosed);
    const [isMobileDrawerVisible, setIsMobileDrawerVisible] = useState(false);
    const [maxWidth, setMaxWidth] = useState(props.maxWidth || 'unset');

    useEffect(() => {
        if (isSidebarVisible && refContainer?.current && maxWidth === 'unset') {
            setMaxWidth(refContainer.current.offsetWidth);
        }
    }, [canClose, refContainer, isSidebarVisible]);

    // useEffect(() => {
    //     if (!canClose) {
    //         setMaxWidth('unset')
    //     }else {
    //         setIsSidebarVisible(true);
    //     }
    // }, [canClose])

    useEffect(() => {
        if (isMobileDrawerVisible) {
            setIsMobileDrawerVisible(false)
        }

    }, [location.pathname, location.search])

    if (!canClose) {
        return props.children;
    }


    if (breakpoint === 'mobile') {
        return (
            <div className="wp-sidebar-nav">
                <button
                    type="button"
                    className="settings-icon"
                    onClick={() => setIsMobileDrawerVisible(!isMobileDrawerVisible)}
                >
                    {props.openIcon || <i className="fas fa-sliders-h"/>}
                </button>
                <Drawer
                    // height={"auto"}
                    placement="left"
                    closable={false}
                    onClose={() => setIsMobileDrawerVisible(!isMobileDrawerVisible)}
                    open={isMobileDrawerVisible}
                // getContainer={drawerContainerRef.current}
                // rootStyle={{ position: 'absolute' }}
                >
                    {props.children}
                    <button
                        type="button"
                        className="p-3 absolute right-0 top-0"
                        onClick={() => setIsMobileDrawerVisible(!isMobileDrawerVisible)}
                    >
                        <i className="fas fa-times" />
                    </button>
                </Drawer>
            </div>
        )
    }

    return (
        <div
            className={TB.mapClass("wp-sidebar-nav hidden md:flex", {
                "open": isSidebarVisible || !canClose
            })}
            style={isSidebarVisible ? { width: maxWidth } : {}}
        >
            <button
                type="button"
                className="clickable settings-icon"
                onClick={() => setIsSidebarVisible(!isSidebarVisible)}
            >
                <i className="fas fa-caret-left" />

                {props.openIcon || <i className="fas fa-sliders-h"/>}
            </button>
            <div ref={refContainer} className="wp-sidebar-container">
                {props.children}
            </div>

        </div>
    )
};

export default SidebarComponent;